import filters, { Filters } from '@gin-betting/filters';

import moduleLocator from 'moduleLocator';
import { MobileFiltersCtx } from './components/MobileFilters/MobileFiltersCtx';
import * as components from './components';
import * as constants from './constants';
import * as utils from './utils';

export type { Filters };

const filtersModule = {
    ...filters,
    components,
    MobileFiltersCtx,
    utils: { ...filters.utils, ...utils },
    constants: { ...filters.constants, ...constants },
};

moduleLocator.set('filters', { default: filtersModule });

export default filtersModule;
